import { createFileRoute, redirect } from '@tanstack/react-router';

// Root index route - redirects to /studio
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({
      to: '/studio'
    });
  }
});
